// extracted by mini-css-extract-plugin
export default {"parameter":"FDmCQ","name":"p1m_Q","note":"oQV8G"};